import type { GroupViewState, ReduxAction } from '@repo/utils/types';

const initialGroupState = {
  group: null,
  initialGroupState: null,
  isEditing: false,
  isEditingContacts: false,
};

export function groupViewReducer(
  state: GroupViewState = initialGroupState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    // a contact can be selected either by viewing that contact's profile or by
    // highlighting the row of that contact in search/inbox/reminders/group detail view
    case 'SET_GROUP_IN_VIEW':
      return {
        ...state,
        group: payload.group || null,
        initialGroupState: payload.group || null,
        isEditing: false,
      };

    case 'START_GROUP_EDITING':
      return {
        ...state,
        isEditing: !state.group.is_internal,
      };

    case 'STOP_GROUP_EDITING':
      return {
        ...state,
        isEditing: false,
      };

    case 'START_GROUP_CONTACT_EDITING':
      return {
        ...state,
        isEditingContacts: true,
      };

    case 'STOP_GROUP_CONTACT_EDITING':
      return {
        ...state,
        isEditingContacts: false,
      };

    case 'RESET_GROUP_IN_VIEW':
      return {
        ...state,
        isEditingContacts: false,
        isEditing: false,
        group: payload?.group || state.initialGroupState,
      };

    case 'UPDATE_GROUP_IN_VIEW':
      return {
        ...state,
        group: payload.group,
      };

    case 'DELETE_CONTACT_REQUESTED':
      if (state.group) {
        return {
          ...state,
          group: state.group?.removeContactByID(payload.id),
        };
      }

      return state;

    case 'DELETE_CONTACT_BATCH_REQUESTED':
      if (state.group) {
        return {
          ...state,
          group: state.group?.removeContactGroupByIDs(payload.contact_ids),
        };
      }

      return state;

    default:
      return state;
  }
}
